// Central place that reads analytics-related env vars so nothing else in the
// app touches process.env directly for this concern.
const analyticsConfig = {
  ga4MeasurementId: process.env.REACT_APP_GA4_MEASUREMENT_ID || "",
  // Sends real hits only in production by default so local/dev/test work
  // doesn't pollute GA4 data. Set REACT_APP_ANALYTICS_FORCE_ENABLE=true to
  // opt in to real tracking from a non-production build (e.g. staging).
  isEnabled:
    process.env.REACT_APP_ANALYTICS_FORCE_ENABLE === "true" ||
    process.env.NODE_ENV === "production",
  debug: process.env.REACT_APP_ANALYTICS_DEBUG === "true",
};

export default analyticsConfig;
